var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-map",style:({ height: _vm.height })},[(_vm.showMarker)?_c('div',{staticClass:"map-marker"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }